import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import Header from './header'
import Footer from './footer'
import Content from './content'
import useMessageDeletion from '../../../hooks/use-message-deletion'
import useClientLocation from '../../../hooks/use-client-location'
import useCurrentUser from '../../../hooks/use-current-user'

const MessageItem = ({
    message = {}
}) => {
    const { currentUser } = useCurrentUser()
    const [ expanded, setExpanded ] = useState(true)
    const { deleteMessage } = useMessageDeletion({ messageId: message.id})
    const { toMessageUser } = useClientLocation()

    return (
        <Row style={{ padding: '10px' }}>
            <Col xs={{ span: 10, offset: 1 }}>
                <Row style={{ backgroundColor: 'rgb(241,249,255)'}}>
                    <Col>
                        <Header
                            user={message.recipient}
                            subject={message.subject}
                            expanded={expanded}
                            onToggle={() => setExpanded(!expanded)}
                        />
                        { expanded &&
                            <Content
                                date={message.createdDate}
                                content={message.content}
                            />
                        }
                        { expanded &&
                            <Footer
                                onDelete={() => deleteMessage()}
                                onReply={() => toMessageUser(message.authorId, `re: ${message.subject}`)}
                                canReply={currentUser.id !== message.authorId}
                            />
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default MessageItem